module.exports = __webpack_public_path__ + "media/images/icons/icon-notifications-29f0d9afa40e6a616c03af9f77630c4e.png";